import axios from 'axios';
import { API_URL } from '../config';
import { getToken } from '../helpers/common';

export const login = (credentials) => {
  const URL = `${API_URL}/auth/login`;
  return axios.post(URL, { ...credentials }).then((response) => response.data);
};

export const logout = () => {
  const URL = `${API_URL}/auth/logout`;
  return axios.post(URL, {}, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  }).then((response) => response.data);
};

export const refreshTokenRequest = () => {
  const URL = `${API_URL}/auth/token`;
  return axios.get(URL).then((response) => response.data);
};

export const sendRecoveryLink = (data) => {
  const URL = `${API_URL}/auth/recovery`;
  return axios.post(URL, data).then((response) => response.data);
};

export const signup = (data) => {
  const URL = `${API_URL}/auth/signup`;
  return axios.post(URL, data).then((response) => response.data);
};
export const reset = (data) => {
  const URL = `${API_URL}/auth/reset`;
  return axios.post(URL, data).then((response) => response.token);
};
